export default {"src":"/_next/static/media/raccoon_happy.e82cc2b2.svg","height":306,"width":354};